module.exports = __webpack_public_path__ + "static/media/deploy-logo2x.faba0ed3.png";